// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33sO_","inner":"Footer_inner__P0-hc"};